import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../../../stories/Title/Title";
import Close from "../../../../../../../images/Close.svg";
import TextArea from "../../../../../../../stories/TextArea/TextArea";
import { Button } from "../../../../../../../stories/Button/Button";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  getItemDetailsByNodeForTicket,
  ticketDetailsByNodeId,
} from "../../../queries/queriers";
import { nodeVar } from "../../../../../../../utils/commonQueryTypes";
import {
  AtsTicketDetails,
  UpdateTicketDetailsResult,
  UpdateTicketDetailsVariables,
} from "../../../queries/types";

import { MapsContext } from "../../../context/context";
import { UpdateTicketDetails } from "../../../queries/mutations";
import useUrlParams from "../../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../../customHooks/useLoggedInUserDetails";
import { emptyMessage } from "../../../../../../../utils/constants";
import { msgType } from "../../../../../../../utils/types";
import { Operation } from "../../../../../../../utils/Enum.types";
import MessageModal from "../../../../../../../customComponents/MessageModal";
import { GetTicketDetailsForFollowUp } from "../../../../masters/items/queries/queries";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const EditVendorResponse = ({ setModalFlag }: Props) => {
  const [remarks, setRemarks] = useState("");
  const [previousMessage, setPreviousMessage] = useState("");

  const { state } = useContext(MapsContext);
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const [GetDetails, { data }] = useLazyQuery<
    { node: AtsTicketDetails },
    nodeVar
  >(ticketDetailsByNodeId);

  const [message, setMessage] = useState<msgType>(emptyMessage);

  const [Update] = useMutation<
    UpdateTicketDetailsResult,
    UpdateTicketDetailsVariables
  >(UpdateTicketDetails);
  useEffect(() => {
    if (state.ticketDetailsId )
      GetDetails({
        variables: {
          
          id: state.ticketDetailsId,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setPreviousMessage(data.node.remarks);
        }
      });
  }, [GetDetails, state.ticketDetailsId, data]);

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      setRemarks("");
      setPreviousMessage("");
      setModalFlag(false);
    }
    setMessage(emptyMessage);
  };

  const handleSubmit = async () => {
    Update({
      variables: {
        customerID: customer_id!,
        ticketDetailsID: state.ticketDetailsId,
        input: {
          remarks,
          imagesPath: "",
        },
        
        user_details,
      },
      refetchQueries: [
        {
          query: getItemDetailsByNodeForTicket,
          variables: {
            
            id: state.ticketDetailsId,
          },
        },
        {
          query: GetTicketDetailsForFollowUp,
          variables: {
            customerID: customer_id!,
            ticketID: state.ticketId,
            
          },
        },
      ],
    }).then(({ data }) => {
      if (data && data.UpdateTicketDetails) {
        setMessage({
          flag: true,
          message: "Updated Successfully",
          operation: Operation.CREATE,
        });
      }
    });
  };

  return (
    <div className="edit-vendor-response">
      <div className="edit-vendor-response__title">
        <Title>Edit Details</Title>
        <img src={Close} alt="" onClick={() => setModalFlag(false)} />
      </div>
      <div className="edit-vendor-response__form">
        <TextArea
          rows={3}
          placeholder="Type here..."
          onChange={(e) => {
            setRemarks(e.target.value);
          }}
          autoFocus
        />

        <div className="edit-vendor-response__form--text">
          {previousMessage}
        </div>
      </div>

      <Button mode="save" onClick={handleSubmit} />
      <Button mode="cancel" onClick={() => setModalFlag(false)} />
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default EditVendorResponse;
